import React from "react";
import Wrapper from "./footer.styles";
import { currentYear } from "../../utils/helpers/dateHelper";
import environmentSettings from "@constants/environmentSettings";

const Footer = () => {
  const { companyName, abn, acl } = environmentSettings;

  return (
    <Wrapper>
      <div className="copyright-container">
        <p>
          © 2012-{currentYear} {companyName} &#x2022; ABN {abn} <br/> Australian Credit Licence {acl}
        </p>
      </div>
      <div className="copyright-container-desktop">
        <p>
          © 2012-{currentYear} {companyName} <br/> ABN {abn} <br/> Australian Credit Licence {acl}
        </p>
      </div>
      <div className="lock-container">
        <p>
          <span>Secure &amp; Private</span> &#x2022; Your info is safe with us
        </p>
      </div>
      <div className="lock-container-desktop">
        <p>
          <span>Secure &amp; Private</span> <br/> Your info is safe with us
        </p>
      </div>
    </Wrapper>
  );
};

export default Footer;
